import { Tabs } from 'antd';
import React, { Component } from 'react';
import {dbFields}  from '../../model/device/column';
import {  Form, Input, Button,Divider,message, Upload,Select} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {  getCustomList } from "../../model/customs/requests";
import BreadcrumbCustomer from "../breadcrumb";
import { createDevice,exportDeviceByCustomId,ImportDevice } from '../../model/device/requests';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import { route } from "../../routes/routes";
import * as XLSX from "xlsx";

export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};
const Option = Select.Option;



class DeviceExport extends React.Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            customList:[],
            custom_id:"",
            custom_name:"",
            fileList: [],
        }
    }

    beforeUpload = (file) => {
        
        if ( file.name.indexOf('.csv') === -1 ) {
            message.error('you can only upload "CSV" format file ')
        }
        return false;
   };

   onChangeEvent = (info)=>{
    if ( info.file.name.indexOf('.csv') !== -1 ) {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
    //   console.log(fileList.length)
        if (fileList.length === 1) {
            this.setState({
                visiable:false
            })
        }
        this.setState({ fileList })
    }
}


onRemoveEvent = (file)=>{
    const { fileList } = this.state;
    const index = fileList.indexOf(file);
    let newFileList = fileList.slice();
    newFileList.splice(index, 1);
    if (newFileList.length < 1) {
        this.setState({
            visiable: true
        })
    }
    this.setState({
        fileList: newFileList
    })
};

    handlerUpload = (e) => {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file.originFileObj);
        });
       ImportDevice(formData).then(res=>{
        if(res.data.code === 200){
            message.success("upload success")
            this.setState({
                fileList:[],
            })
       }else{
           message.error("Upload Failed")
       }
       }).catch(err=>{
        message.error(err)
       })
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    handlerSubmit = (e) => {
        let imei = this.formRef.current.getFieldValue("imei");
        let cid = this.state.custom_id
        createDevice({imei:imei,cid:cid}).then(res=>{
        if(res.data.code === 200){
            message.success(configs.http.responseMsg.created)
            setTimeout(()=>{
                this.props.history.push(route.search.device)
            },1000)
           
        }else{
            message.error(res.data.msg)
        }
       }).catch(err=>{
        message.error(err)
       })
       
    }

    // handlerCustomChange = (value,option) => {
    //     let custom_id = option.attr
    //     this.setState({
    //         custom_id:custom_id
    //     })
    // }

    handlerCustomChange = (item) => {
        let custom_id = item
        this.setState({
            custom_id:custom_id
        })
    }

    handlerExport = () => { 
        let custom_id = this.state.custom_id
        if (custom_id == "" || custom_id.length == 0 ) {
            message.error("Please select a custom")
            return 
        }
        exportDeviceByCustomId({cid:custom_id}).then(res => { 

            if(res.data.code == 200){
                const data = res.data.data;
                console.log(data)
                // 检查响应数据格式
                if (!Array.isArray(data)) {
                    throw new Error('数据格式不正确');
                }
      
                const customHeaders = [
                  { header: 'Imei', key: 'imei' },
                  { header: 'Imei2', key: 'imei2' },
                  { header: 'Curef', key: 'curef' },
                  { header: 'Custom Id', key: 'custom_id' },
                  { header: 'Device Status', key: 'status' },
                  { header: 'Last On Line', key: 'last_check_online' },
                  { header: 'Activation Date', key: 'activation_date' },
                  { header: 'Wifi Mac', key: 'wifi_mac' },
                  { header: 'Wifi Mac2', key: 'wifi_mac2' },
                  { header: 'Device id', key: 'device_id' },
                  { header: 'Device info', key: 'device_info' },
                  { header: 'Devos id', key: 'devos_id' },
                  { header: 'Endpoint', key: 'endpoints' },
                  { header: 'Is Lock', key: 'is_lock' },
      
              ];
      
      
                // 将数据转换为工作表
                const worksheet = XLSX.utils.json_to_sheet(data);
      
                 // 设置表头
                 const headerRow = customHeaders.map(header => header.header);
                 XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A1' });
      
                 // 将数据填充到工作表中
                 const dataRow = data.map(item => (
                   {
                     imei: item.imei,
                     imei2:item.imei2,
                     curef:item.curef,
                     custom_id:item.custom_id,
                     status:item.status,
                     last_check_online:item.last_check_online,
                     activation_date:item.activation_date,
                     wifi_mac:item.wifi_mac,
                     wifi_mac2:item.wifi_mac2,
                     device_id:item.device_id,
                     device_info:item.device_info,
                     devos_id:item.devos_id,
                     endpoints:item.endpoints,
                     is_lock:item.is_lock,
    
                 }
                 ));

                 XLSX.utils.sheet_add_json(worksheet, dataRow);
                 // 创建工作簿
                 const workbook = XLSX.utils.book_new();
                 XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
      
                // 生成 Excel 文件
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
                // 创建 Blob 对象
                const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'device.xlsx'); // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }else{
                message.warn(res.data.msg)
            }

            // Todo export
        }).catch(err=>{
            console.log(err)
            message.error("Export Failed")
        })
    }

    componentDidMount(){
        let customList = [];
        getCustomList().then(res=>{
            if(res.data.code === 200){
                customList = res.data.data
                this.setState({
                    customList:customList
                })
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })
    }
    render(){
        const {customList} = this.state
        return (
            <>
                <BreadcrumbCustomer first='Device' second='Export' />
                <Divider />
  
                        <Form
                            {...layout}
                            ref={this.formRef}
                        >
                            <Form.Item label={"CustomerID"} name={"custom_id"}>
                                <Select 
                            
                                    onChange={this.handlerCustomChange}
                                >
                                {customList.length > 0  && customList.map((items) => {
                                    return (<Option attr={items.name} key={items.id} value={items.id}> {items.name} </Option>)
                                })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                wrapperCol={{
                                    span: 12,
                                    offset: 6,
                                }}
                            >
                                <Button
                                 
                                    type="primary" 
                                    style={{background: "#851dd6" }}
                                    disabled = {false}
                                    onClick={this.handlerExport}
                                >
                                   Export Data
                                </Button>
                            </Form.Item>    
                        </Form>
            </>
        )
    }
}


export default DeviceExport;